import React, { useState } from "react";
import { Outlet } from "react-router-dom";
import DriverSidebar from "../components/layout/DriverSidebar";
import DriverTopbar from "../components/layout/DriverTopbar";

const shellStyle: React.CSSProperties = {
  minHeight: "100vh",
  background: "var(--background)",
  color: "var(--text-primary)",
  display: "flex",
};

const contentShellStyle: React.CSSProperties = {
  flex: 1,
  minWidth: 0,
  display: "flex",
  flexDirection: "column",
};

const mainStyle: React.CSSProperties = {
  flex: 1,
  padding: "24px",
};

const innerContentStyle: React.CSSProperties = {
  width: "100%",
};

const DriverLayout = () => {
  const [collapsed, setCollapsed] = useState<boolean>(false);

  const handleToggleSidebar = () => {
    setCollapsed((prev) => !prev);
  };

  return (
    <div style={shellStyle}>
      <DriverSidebar collapsed={collapsed} />

      <div style={contentShellStyle}>
        <DriverTopbar
          collapsed={collapsed}
          onToggleSidebar={handleToggleSidebar}
        />

        <main style={mainStyle}>
          <div style={innerContentStyle}>
            <Outlet />
          </div>
        </main>
      </div>
    </div>
  );
};

export default DriverLayout;